import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Container, Row, Col, Image, Spinner } from 'react-bootstrap';
import { agoraChatGroupName, changeBodyClassName } from '../../../utils/utils';
import iconEdit from '../../../assets/icon/icon-edit.png';
import svg from '../../../assets/images/Avatar.svg';
import starIcon from '../../../assets/icon/icon-my-room-star.svg';
import flagIcon from '../../../assets/icon/icon-my-room-flag.svg';
import { bg } from '../../../constants/component.constants';
import { useAuth } from '../../auth/Auth';
import '../my_room/css/myroom.scss';
import PartnerHeader from './PartnerHeader';
import MyBadge from '../../common/MyBadge';
import {
  CHALLENGE_ROUTE,
  PARTNER_LOGIN,
  SCHOOL_ADD_CHALLENGES,
  SCHOOL_LOGIN,
} from '../../../constants/routes.constants';
import { partnerViewModel } from './partner.view.model';
import TreehouseSelectbox from './TreehouseSelectBox';
import PersonalizeProfileModal from './PersonalizeProfileModal';
import defaultBannerImg from '../../../assets/images/bg_MyRoom.svg';
import EventEmitter from '../../../utils/events';
import notVerified from '../../../assets/icon/Unverified.svg';
import verified from '../../../assets/icon/Verified-badge.svg';
import { schoolViewModel } from './school.view.model';
import TreehouseCreatedModal from './TreehouseCreatedModal';
import ChallengeModal from '../../common/ChallengeModal';
import greenTick from '../../../assets/icon/green_tick.svg';
import { agoraViewModel } from '../../common/agora.view.model';
import MyRoomLeftSideBar from '../my_room/MyRoomLeftSideBar';
import MyRoomRightSideBar from '../my_room/MyRoomRightSideBar';
import TribeRoom from '../my_room/TribeRoom';
import ChallengeList from './ChallengesList';
import PersonalizeProfileCampCaptain from './PersonalizeProfileCampCaptain';
import CampUnverifiedModal from '../../common/CampUnverifiedModal';
import CampRestrictModal from './CampRestrictModal';
import InfiniteScroll from 'react-infinite-scroller';
import Home from '../../../assets/icon/header/Home.svg';
import HomeActive from '../../../assets/icon/header/Home_active.svg';
import Challenge from '../../../assets/icon/header/City.svg';
import ChallengeActive from '../../../assets/icon/header/City_active.svg';
import FeedGallery from '../feed/FeedGallery';
import './camp-room.css';

const CampChallenges = () => {
  const history = useHistory();
  const { school, partner, isLoading } = useAuth();
  const userName = school
    ? school?.user_type === 'school'
      ? school.school_name
      : school?.first_name + ' ' + school?.last_name
    : '';
  const [challengeCount, setChallengeCount] = useState(0);
  const [creationCount, setCreationCount] = useState(0);
  const [subscriptionCount, setSubscriptionCount] = useState(0);
  const [tabFlag, setTabFlag] = useState('challenge');
  const [treehousesList, setTreehousesList] = useState([]);
  const [selectedTreehouse, setSelectedTreehouse] = useState('All');
  const [customizePopup, setCustomizePopup] = useState(false);
  const [captainCustomizePopup, setCaptainCustomizePopup] = useState(false);
  const [isDisabled, setIsDisabled] = useState(partner ? false : true);
  const defaultProfileUrl =
    school?.user_type === 'school'
      ? school.picture_url
        ? school.picture_url
        : svg
      : school?.profile?.picture_url
      ? school?.profile?.picture_url
      : svg;
  const defaultBannerUrl = school && school.banner_url ? school.banner_url : '';
  const [profilePic, setProfilePic] = useState(defaultProfileUrl);
  const [bgImg, setBgImg] = useState(defaultBannerUrl);
  const [upcomingChallengeList, setUpcomingChallengeList] = useState([]);
  const [liveChallengeList, setLiveChallengeList] = useState([]);
  const [pastChallengeList, setPastChallengeList] = useState([]);
  const [challengeList, setChallengeList] = useState([]);
  const [creationList, setCreationList] = useState([]);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteChallengeId, setDeleteChallengeId] = useState();
  const [appToken, setAppToken] = useState();
  const [deleteChallengeGroup, setDeleteChallengeGroup] = useState(null);
  const [leftCollapsse, setLeftCollapsse] = useState('');
  const [rightCollapsse, setRightCollapsse] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState({});
  const [loading, setLoading] = useState(false);
  const [creationLoading, setCreationLoading] = useState(false);
  const [campLoading, setCampLoading] = useState(true);
  const [showUnverifiedCampModal, setShowUnverifiedCampModal] = useState(false);
  const [showRestrictCampModal, setShowRestrictCampModal] = useState(false);
  const [treehouseCode, setTreehouseCode] = useState(
    history.location.state ? history.location.state.treehouseCode : ''
  );
  const [isOpen, setIsOpen] = useState(
    history.location.state && history.location.state.from === 'add_treehouse'
      ? true
      : false
  );
  const [query, setQuery] = useState({
    limit: 9,
    has_more: true,
  });

  const [creationQuery, setCreationQuery] = useState({
    limit: 9,
    has_more: true,
  });

  const [upcomingQuery, setUpcomingQuery] = useState({
    limit: 9,
    has_more: true,
    availability: 'upcoming',
  });

  const [currentQuery, setCurrentQuery] = useState({
    limit: 9,
    has_more: true,
    availability: 'current',
  });

  const [pastQuery, setPastQuery] = useState({
    limit: 9,
    has_more: true,
    availability: 'previous',
  });

  useEffect(() => {
    setProfilePic(defaultProfileUrl);
  }, [defaultProfileUrl]);

  useEffect(() => {
    setBgImg(defaultBannerUrl);
  }, [defaultBannerUrl]);

  const getTreehouses = () => {
    if (school) {
      const params = {
        limit: 99,
      };
      let API =
        school?.user_type === 'school'
          ? schoolViewModel?.getCampMasterTribes
          : schoolViewModel?.getCampCaptainTribes;
      // schoolViewModel.getTeachers().then((res) => {
      API(school?.id, params)
        .then((res) => {
          setTreehousesList(res);
          for (let index = 0; index < res.length; index++) {
            getUser(res[index]);
          }
          setCampLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setCampLoading(false);
        });
    }
  };

  const onAddChallenge = () => {
    if (!school?.is_verified) {
      setShowUnverifiedCampModal(true);
      return;
    }
    if (school?.subcription_type !== 'premium') {
      setShowRestrictCampModal(true);
      return;
    }
    if (school) {
      history.push({
        pathname: SCHOOL_ADD_CHALLENGES,
        state: {
          treehouseId: selectedTreehouse[0].id,
          treehouse_agora_group_id:
            selectedTreehouse[0]?.profile?.agora_group_id,
          selectedTribe: JSON.stringify(selectedTreehouse[0]),
          isCampMaster:
            school?.user_type === 'school' && !selectedTreehouse[0]?.id,
        },
      });
    }
  };

  let myRoomImageStyle = {
    backgroundImage: bgImg ? `url(${bgImg})` : `url(${defaultBannerImg})`,
  };

  const getBadgeCount = () => {
    if (school?.user_type === 'school') {
      let API = schoolViewModel.getBadgeCount;
      API(school?.id)
        .then((res) => {
          setChallengeCount(res.challenge_count);
          setCreationCount(res.creation_count);
          if (res.subscription_count) {
            setSubscriptionCount(res.subscription_count);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  useEffect(() => {
    changeBodyClassName([bg.WHITE]);
    getBadgeCount();
  }, [school]);

  const handleDelete = (challenge) => {
    setDeleteChallengeId(challenge.id);
    if (
      challenge.created_by?.user_type === 'school_teacher' &&
      challenge.agora_group_id
    ) {
      setDeleteChallengeGroup(challenge.agora_group_id);
    } else {
      setDeleteChallengeGroup(null);
    }
    setShowDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = () => setShowDeleteConfirm(false);

  const deleteChallenge = () => {
    if (deleteChallengeGroup) {
      let params = {
        appToken: appToken,
        id: deleteChallengeGroup,
      };
      // agoraViewModel.deleteGroup(params)
    }
    partnerViewModel
      .deleteChallenge(deleteChallengeId)
      .then((res) => {
        setShowDeleteConfirm(false);
        getChallenges();
        getBadgeCount();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChallengeClick = (id) => {
    let path = CHALLENGE_ROUTE;
    let encodeQuery = btoa(`{"id":${id}, "slug":"challenge"}`);
    history.push({
      pathname: path,
      search: `?encrypt=${encodeQuery}`,
    });
  };

  const getUserProfilePic = (image) => {
    setProfilePic(image.preview);
  };

  const getUserBannerPic = (image) => {
    setBgImg(image.preview);
  };

  EventEmitter.subscribe('partner_profile_pic', getUserProfilePic);
  EventEmitter.subscribe('partner_banner_pic', getUserBannerPic);

  const getAppToken = async () => {
    let res = await agoraViewModel.getAppToken();
    setAppToken(res.data.app_token);
  };

  const createGroup = async (treehouse) => {
    const data = {
      groupname: agoraChatGroupName(treehouse?.name),
      desc: treehouse?.name,
      public: true,
      owner: String(treehouse?.id),
    };
    const token = appToken;

    try {
      await agoraViewModel.createGroup(token, data).then((response) => {
        let body = {
          name: treehouse?.name,
          day: treehouse?.day,
          time: treehouse?.time,
          time_zone: treehouse?.timezone,
          age_group: treehouse?.age_group,
          camp_captain_id: treehouse?.captain_details?.id,
          agora_group_id: response?.data?.groupid,
          agora_chat_box: false,
        };
        schoolViewModel
          .ediTribe(treehouse.id, body)
          .then((res) => {
            getTreehouses();
          })
          .catch((err) => {
            console.log(err);
            let params = {
              appToken: appToken,
              id: response?.data?.groupid,
            };
            agoraViewModel.deleteGroup(params);
          });
      });
    } catch (err) {
      console.error(err);
    }
  };

  const getUser = async (treehouse) => {
    let data = {
      username: treehouse.id,
      appToken: appToken,
    };
    await agoraViewModel
      .getUser(data)
      .then((res) => {
        if (!treehouse?.agora_group_id) createGroup(treehouse);
      })
      .catch((err) => {
        if (err.statusCode === 404) {
          registerUser(treehouse);
        }
      });
  };

  const registerUser = (treehouse) => {
    let data = {
      username: treehouse.id,
      nickname: treehouse.id,
      password: 'test@123',
      appToken: appToken,
    };
    agoraViewModel
      .registerUser(data)
      .then((res) => {
        createGroup(treehouse);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAppToken();
  }, []);

  useEffect(() => {
    if (appToken) getTreehouses();
  }, [appToken]);

  const handleMemberCLick = (member) => {
    setSelectedMember(member);
  };

  const getAPI = () => {
    return schoolViewModel.getUpcomingChallenges;
  };

  const fetchFun = async (API, params, list) => {
    setLoading(true);
    const type = partner?.user_type;
    try {
      const res = await API(params, list, type);
      setChallengeList(res.newList);
      setQuery(res.query);
    } catch (err) {
      console.log(err);
      if (err.statusCode === 500) {
        history.push(SCHOOL_LOGIN);
      }
    }
    setLoading(false);
  };

  const fetchFunCreation = async (API, params, list) => {
    setCreationLoading(true);
    try {
      const res = await API(params, list);
      setCreationList(res.List);
      setCreationQuery(res.query);
    } catch (err) {
      console.log(err);
    }
    setCreationLoading(false);
  };

  const getCreations = (list, query) => {
    let params = { ...query };
    if (selectedTreehouse && selectedTreehouse !== 'All') {
      params.group_id = selectedTreehouse[0]?.id;
    }
    const API = schoolViewModel.getCampCreations;
    if (API) {
      if (!creationLoading) fetchFunCreation(API, params, list);
    } else {
      setCreationLoading(false);
    }
  };

  const getChallenges = (list, query) => {
    let params = { ...query };
    if (selectedTreehouse && selectedTreehouse !== 'All') {
      params.group_id = selectedTreehouse[0]?.id;
    }
    // params.availability = tabFlag;
    const API = getAPI();
    if (API) {
      if (!loading) fetchFun(API, params, list);
    } else {
      setLoading(false);
    }
  };

  const handleChange = () => {
    const list = [];
    const query = {
      limit: 9,
      has_more: true,
    };
    setChallengeList(list);
    setCreationList(list);
    setQuery(query);
    setCreationQuery(query);
    getChallenges(list, query);
    getCreations(list, query);
  };

  const getInfiniteChallenges = () => {
    getChallenges(challengeList, query);
  };

  const getInfiniteCreations = () => {
    getCreations(creationList, creationQuery);
  };

  useEffect(() => {
    handleChange();
  }, [selectedTreehouse]);

  const handleEditClick = () => {
    if (school?.user_type === 'school') {
      setCustomizePopup(true);
    } else {
      setCaptainCustomizePopup(true);
    }
  };

  const loader = (
    <Spinner
      key={0}
      className="myroom-spinner"
      animation="border"
      variant="info"
    />
  );

  const handleBinky = (creationId, binkyId, binkyCount) => {
    const newList = creationList.map((obj) => {
      return obj.id === creationId
        ? {
            ...obj,
            binky_count: binkyCount,
            binky_id: binkyId,
          }
        : obj;
    });
    setCreationList(newList);
  };

  const handleComment = (creationId, newCommentCount) => {
    const newList = creationList.map((obj) => {
      return obj.id === creationId
        ? {
            ...obj,
            comment_count: newCommentCount,
          }
        : obj;
    });
    setCreationList(newList);
  };

  return (
    <div className="room-expansion camp-common-room-container myroom-main partner_myroom_main partner-wrapper-main">
      {!isLoading && school ? (
        <>
          <PartnerHeader />
          <div className="flex-wrapper">
            <MyRoomLeftSideBar
              handleMemberCLick={handleMemberCLick}
              treehousesList={treehousesList}
              myInterests={true}
              setLeftCollapsse={setLeftCollapsse}
              setShowModal={setShowModal}
              selectedTreehouse={selectedTreehouse}
              selectedMember={selectedMember}
              rightCollapsse={rightCollapsse}
              setSelectedMember={setSelectedMember}
            />
            <div className="myroom-profile-info">
              <div
                className={
                  'flex-col-center ' + rightCollapsse + ' ' + leftCollapsse
                }
              >
                {selectedMember.id ? (
                  <TribeRoom
                    creator={selectedMember}
                    setSelectedMember={setSelectedMember}
                  />
                ) : (
                  <>
                    <CampRestrictModal
                      showModal={showRestrictCampModal}
                      setShowModal={setShowRestrictCampModal}
                    />
                    <ChallengeModal
                      handleClose={handleCloseDeleteConfirm}
                      handleAction={deleteChallenge}
                      show={showDeleteConfirm}
                      type="confirm"
                      level="warning"
                      button1Label="Delete"
                      button2Label="Cancel"
                    >
                      <div>
                        <span>
                          Are you sure you want to delete this challenge?
                        </span>
                      </div>
                    </ChallengeModal>
                    <Container
                      className={
                        bgImg
                          ? 'myroom-info-container overlay-container container new-banner-image'
                          : 'myroom-info-container  overlay-container container'
                      }
                      style={myRoomImageStyle}
                    >
                      <Row className="myroom-info-wrapper">
                        <Col md={7} lg={7} xl={8}>
                          <div className="myroom-collapse">
                            <div className="avatar-wrapper">
                              <div className="full-big-type">
                                <Row>
                                  <div className="avatar-image">
                                    <Image
                                      className="rounded-circle profile-image"
                                      src={profilePic}
                                    />
                                    <Image
                                      className="edit-button"
                                      onClick={handleEditClick}
                                      src={iconEdit}
                                    />
                                  </div>
                                  <div className="user-info">
                                    <div className="name-favorites">
                                      <div className="user-name">
                                        {userName}
                                        {school && (
                                          <Image
                                            className="blue_badge remove-pointer"
                                            src={
                                              !school?.is_verified
                                                ? notVerified
                                                : school?.user_type === 'school'
                                                ? greenTick
                                                : verified
                                            }
                                          />
                                        )}
                                      </div>
                                      <div className="favorites">
                                        {school && school?.description}
                                      </div>
                                    </div>
                                  </div>
                                </Row>
                                {school?.user_type === 'school' && (
                                  <Row className="badge-wrapper">
                                    <MyBadge
                                      icon={flagIcon}
                                      count={challengeCount}
                                      className="first-badge"
                                      title="Challenges published"
                                    />
                                    <MyBadge
                                      icon={starIcon}
                                      count={creationCount}
                                      title="Creations submitted"
                                    />
                                  </Row>
                                )}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 4 }}>
                          <div className="join-camp-wrapper">
                            <div className="filter-container">
                              <div className="filter-tag">
                                <TreehouseSelectbox
                                  treehousesList={treehousesList}
                                  selectedTreehouse={selectedTreehouse}
                                  setSelectedTreehouse={setSelectedTreehouse}
                                  setIsDisabled={setIsDisabled}
                                  setUpcomingChallengeList={
                                    setUpcomingChallengeList
                                  }
                                  setPastChallengeList={setPastChallengeList}
                                  setLiveChallengeList={setLiveChallengeList}
                                  setUpcomingQuery={setUpcomingQuery}
                                  setPastQuery={setPastQuery}
                                  setCurrentQuery={setCurrentQuery}
                                />
                              </div>
                            </div>
                            <Button
                              variant="outline-light common-round-btn btn btn-block"
                              onClick={onAddChallenge}
                              disabled={
                                school?.user_type === 'school_teacher' &&
                                !selectedTreehouse[0]?.id
                              }
                              id="captain-step-setchallenge"
                            >
                              + Set Challenge
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                    <Col className="myroom-creation-title">
                      <div
                        className={`tab tab-left pt-4 pb-2 ${
                          tabFlag === 'creation' ? 'selected' : 'unselected'
                        }`}
                        onClick={() => {
                          setTabFlag('creation');
                        }}
                      >
                        <div>
                          <Image
                            src={tabFlag === 'creation' ? HomeActive : Home}
                            alt="challenge"
                          />
                        </div>
                      </div>
                      <div
                        className={`tab tab-left pt-4 pb-2 ${
                          tabFlag === 'challenge' ? 'selected' : 'unselected'
                        }`}
                        onClick={() => {
                          setTabFlag('challenge');
                        }}
                      >
                        <div>
                          <Image
                            src={
                              tabFlag === 'challenge'
                                ? ChallengeActive
                                : Challenge
                            }
                            alt="challenge"
                          />
                        </div>
                      </div>
                    </Col>
                    {tabFlag === 'challenge' && (
                      <Row className="myroom-challenge-container">
                        <InfiniteScroll
                          pageStart={0}
                          loadMore={getInfiniteChallenges}
                          hasMore={query.has_more}
                          initialLoad={false}
                          loader={loader}
                          threshold={150}
                        >
                          <ChallengeList
                            challengeList={challengeList}
                            handleDelete={handleDelete}
                            loading={loading}
                            tabFlag={tabFlag}
                          />
                        </InfiniteScroll>
                      </Row>
                    )}
                    {tabFlag === 'creation' && (
                      <div className={`myroom-creation-container`}>
                        <InfiniteScroll
                          pageStart={0}
                          loadMore={getInfiniteCreations}
                          hasMore={creationQuery.has_more}
                          initialLoad={false}
                          loader={loader}
                          threshold={150}
                        >
                          <FeedGallery
                            feedList={creationList}
                            handleBinky={handleBinky}
                            handleComment={handleComment}
                            isCampRoom={true}
                            isLoading={creationLoading}
                          />
                        </InfiniteScroll>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <TreehouseCreatedModal
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              treehouseCode={treehouseCode}
            />
            {school?.user_type === 'school' ? (
              <PersonalizeProfileModal
                customizePopup={customizePopup}
                setCustomizePopup={setCustomizePopup}
                isEdit={true}
              />
            ) : (
              <PersonalizeProfileCampCaptain
                customizePopup={captainCustomizePopup}
                setCustomizePopup={setCaptainCustomizePopup}
                isEdit={!school?.profile?.picture_url ? false : true}
              />
            )}
            <MyRoomRightSideBar
              selectedTreehouse={selectedTreehouse}
              treehousesList={treehousesList}
              isKidsRoom={true}
              setRightCollapsse={setRightCollapsse}
              isNewChallengesButton={true}
              leftCollapsse={leftCollapsse}
            />
            <CampUnverifiedModal
              showModal={showUnverifiedCampModal}
              setShowModal={setShowUnverifiedCampModal}
            />
          </div>
        </>
      ) : (
        ''
      )}
      {/* {stepsEnabled && pageReady && <CampCaptainTour  tribesList={campTribes} />} */}
    </div>
  );
};
export default CampChallenges;
